function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M469.945,94.325a7.415,7.415,0,1,0,2.173,5.244A7.4,7.4,0,0,0,469.945,94.325Zm-1.087,1.088a5.879,5.879,0,1,1-4.157-1.721A5.862,5.862,0,0,1,468.858,95.413Z",
  transform: "translate(-457.286 -92.153)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463.939,100.325a1.055,1.055,0,1,0,1.055,1.056A1.059,1.059,0,0,0,463.939,100.325Z",
  transform: "translate(-456.486 -90.985)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463.914,94.921a.855.855,0,0,0-.856.855v3.6a.855.855,0,0,0,1.711,0v-3.6A.855.855,0,0,0,463.914,94.921Z",
  transform: "translate(-456.461 -91.757)"
}));

function SvgStatusMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.832,
    height: 14.832,
    viewBox: "0 0 14.832 14.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusMaintenance);
export default __webpack_public_path__ + "static/media/status_maintenance.29aadbaf96d4f7b7e4a9783ccfd28c76.svg";
export { ForwardRef as ReactComponent };